import Service from "@/helpers/py-service";

const state = {
  loading: false,
  //
  upcoming: [],
  live: [],
  history: [],
  walkIn: [],
};

const mutations = {
  SET_LIST(state, { type, list }) {
    state[type] = list;
  },
  SET_Walk_IN_SESSIONS(state, payload) {
    state.walkIn = payload;
  },
};

const actions = {
  list: (store, params) => {
    // store.state.loading = true;
    return Service.get(`bookings/schedule-listing`, params).then((data) => {
      const payload = {
        type: params.filter_type,
        list: data?.body?.bookings,
      };
      store.commit("SET_LIST", payload);
      store.state.loading = false;
      return data?.body?.bookings;
    });
    // .finally(() => (store.state.loading = false));
  },

  details: (store, params) => {
    return Service.get(`bookings/details/${params.booking_id}`)
      .then((data) => {
        return data?.body;
      })
      .finally(() => (store.state.loading = false));
  },
  verifyBooking: (store, params) => {
    return Service.post(`bookings/verify-booking/${params.booking_id}`, params)
      .then((data) => {
        return data?.body;
      })
      .finally(() => (store.state.loading = false));
  },
  getPriceSummary: (store, params) => {
    let URL = `bookings/price-summary/`;
    URL = `${URL}${params.booking_id ? "" : "session/"}${params.id}`;
    return Service.get(`${URL}`)
      .then((data) => {
        return data;
      })
      .finally(() => (store.state.loading = false));
  },
  createPayment: (store, params) => {
    let URL = `bookings/create-payment/`;
    URL = `${URL}${params.booking_id ? "" : "session/"}${params.id}`;
    return Service.post(`${URL}`, params)
      .then((data) => {
        return data?.body;
      })
      .finally(() => (store.state.loading = false));
  },

  //
  walkInSessions: (store, params) => {
    // store.state.loading = true;
    return Service.get(`bookings/walkin-running-sessions`, params)
      .then((data) => {
        store.commit("SET_Walk_IN_SESSIONS", data.body);
        store.state.loading = false;
        return data?.body;
      })
      .finally(() => (store.state.loading = false));
  },
  mapWalkInCustomer: (store, params) => {
    return Service.post(`bookings/map-walkin-session-vehicle`, params)
      .then((data) => {
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },

  //
  downloadInvoice: (store, params) => {
    return Service.get(`bookings/download-receipt/${params.id}`).then(
      (data) => {
        window.open(data.body?.receipt_url, "_blank");
        return data.body;
      }
    );
  },
};

const getters = {
  getLoading(state) {
    return state.loading;
  },

  getUpcoming(state) {
    return state.upcoming;
  },
  getLiveSession(state) {
    return state.live;
  },
  getHistory(state) {
    return state.history;
  },
  getWalkInSessions(state) {
    return state.walkIn;
  },
};

const bookingOperator = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default bookingOperator;
